export default {
      id: "videoWidgetBtn-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#videoWidgetBtn",
      toString: function () {
        return this.url;
      }
    }